<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ this.number ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.CheckIn)">
        <dx-button text="Check In" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.CheckIn)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.NotRequired)">
        <dx-button text="Not Required" type="danger" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.NotRequired)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.Required)">
        <dx-button text="Required" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.Required)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.InvestigationCompleted)">
        <dx-button text="Investigation Completed" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.InvestigationCompleted)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckInAction.CompleteMove)">
        <dx-button text="Complete Move" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckInAction.CompleteMove)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="showMoreMenu">
        <dx-drop-down-button text="More" icon="overflow" [dropDownOptions]="{ width: 210 }" [items]="moreMenuActions"
            [splitButton]="false" stylingMode="outlined" type="default" displayExpr="text" keyExpr="id" [disabled]="isSubmitting"
            (onItemClick)="onMenuActionClick($event)" class="ms-2">
        </dx-drop-down-button>
    </dxi-item>
</dx-toolbar>